<template>
    <v-container class="py-5 px-5" fluid v-if="this.$store.state.signedIn">
        
        <v-layout justify-center align-center>
            <v-flex xs12>
                <dashboard></dashboard>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex class="py-5 px-5">
                <v-card> 
                    <v-card-title :style="$store.state.textFormatting.main">
                        Add or Remove Graph
                    </v-card-title>
                    <v-card-actions>
                        <v-layout row wrap>
                            <v-flex md6 xs12>
                                <v-btn small @click="addtable()" :style="$store.state.textFormatting.main">
                                    <v-icon> add </v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex md6 xs12>
                                <v-btn small @click="removetable()" :style="$store.state.textFormatting.main">
                                    <v-icon> remove </v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-flex>
            <v-flex class="py-5 px-5" xs12>
                <v-container fluid justify-center align-center>
                    <v-layout row wrap>
                        <v-flex xs12 md3 id="tabkey" v-for="i in tablenumber" :key="i" class="py-2 px-2">
                            <dbgraph></dbgraph>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

import asncountrycombo from '../../shared/operational/asn-country-search-combined.vue';
import dbstats from '../../shared/operational/event-to-episode-stats.vue'
import dbgraph from '../../shared/operational/event-to-episode-graph.vue'
import dashboard from '../../shared/developing/stats-dashboard.vue'
import { findParentComponentByName } from '../utils/findParent.js'


export default {
    name: 'statistics',
    components: {
        dbstats,
        asncountrycombo,
        dbgraph,
        dashboard
        
    },
    data () {
        return {
            tablenumber: 1,
            tabkey: 0,
            key: 0
        }
    },
    beforeMount () {
        let app = findParentComponentByName(this, 'app')
        app.checkSignedIn()
    },
    methods: {
        addtable: function () {
            this.tablenumber = this.tablenumber +1
            this.tabkey = this.tabkey+1
        },
        removetable: function () {
            if (this.tablenumber > 0) {
            this.tablenumber = this.tablenumber -1
            this.tabkey = this.tabkey-1
            }
    }

}
}
</script>

